import { store } from "@/store/store";
import {
    VuexModule,
    Mutation,
    getModule,
    Module,
    Action,
} from "vuex-module-decorators";

export interface ToastMessage {
    id: number;
    text: string;
    type: "success" | "error" | "warning" | "info" | "question";
    timeout?: number;
}

export interface AlertDialog {
    show: boolean;
    title: string;
    text: string;
    type: "success" | "error" | "warning" | "info" | "question";
}

export interface ConfirmDialog extends AlertDialog {
    cb?: (res: boolean) => void;
}

@Module({
    namespaced: true,
    name: "messageModule",
    store,
    dynamic: true,
})
class MessageModule extends VuexModule {
    public toasts: ToastMessage[] = [];
    public alert: AlertDialog = {
        show: false,
        title: "",
        text: "",
        type: "success",
    };
    public confirm: ConfirmDialog = {
        show: false,
        title: "",
        text: "",
        type: "question",
    };

    @Mutation
    public PUSH_TOAST(toast: ToastMessage) {
        this.toasts.push(toast);
    }

    @Mutation
    public REMOVE_TOAST(id: number) {
        this.toasts = this.toasts.filter((t) => t.id !== id);
    }

    @Mutation
    public SET_ALERT(payload: AlertDialog) {
        this.alert = payload;
    }

    @Mutation
    public SET_CONFIRM(payload: ConfirmDialog) {
        this.confirm = payload;
    }

    @Action
    public showToast(payload: { text: string; type?: any; timeout?: number }) {
        const id = Date.now();
        const type = payload.type || "success";
        const timeout = payload.timeout || 3000;

        this.PUSH_TOAST({ id, text: payload.text, type, timeout });

        if (timeout > 0) {
            setTimeout(() => {
                this.REMOVE_TOAST(id);
            }, timeout);
        }
    }

    @Action
    public showAlert(payload: { title: string; text?: string; type?: any }) {
        this.SET_ALERT({
            show: true,
            title: payload.title,
            text: payload.text || "",
            type: payload.type || "success",
        });
    }

    @Action
    public closeAlert() {
        this.SET_ALERT({ ...this.alert, show: false });
    }

    @Action
    public showConfirm(payload: {
        title: string;
        text: string;
        cb: (res: boolean) => void;
    }) {
        this.SET_CONFIRM({
            show: true,
            title: payload.title,
            text: payload.text,
            type: "question",
            cb: payload.cb,
        });
    }

    @Action
    public resolveConfirm(res: boolean) {
        if (this.confirm.cb) {
            this.confirm.cb(res);
        }
        this.SET_CONFIRM({ ...this.confirm, show: false });
    }
}

export default getModule(MessageModule);
